import styled from 'styled-components';

export const DashboardMainContainer = styled.div`
	padding: 0.5rem;
	overflow-x: auto;
	height: 100%;
	flex: 1;
`;
